// eslint-disable-next-line no-unused-vars
import React from "react";
import { EmbeddedPage } from "../../../layouts";
import { VehicleSingleRegistrySyncHistoryWidget } from "../widgets/VehicleSingleRegistrySyncHistoryWidget/VehicleSingleRegistrySyncHistoryWidget";

export class VehicleSingleRegistrySyncHistoryWidgetPage
  extends React.Component
{
  render() {
    return (
      <EmbeddedPage>
        <VehicleSingleRegistrySyncHistoryWidget />
      </EmbeddedPage>
    );
  }
}

export default VehicleSingleRegistrySyncHistoryWidgetPage;
